import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Loader2, Receipt } from "lucide-react";
import { toast } from "sonner";
import { Header } from "@/components/Header";
import { getSession, joinSession } from "@/lib/api";
import { getGuest, setGuest } from "@/lib/store";

export default function JoinSession() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSession(code)
      .then((s) => {
        setSession(s);
        const existing = getGuest(code);
        if (existing?.guestId) navigate(`/session/${code}/select`, { replace: true });
      })
      .catch(() => toast.error("Sesiune negăsită"));
  }, [code, navigate]);

  const handleJoin = async () => {
    if (!name.trim()) return toast.error("Scrie-ți numele");
    setLoading(true);
    try {
      const data = await joinSession(code, name.trim());
      setGuest(code, data.guest.id, name.trim());
      navigate(`/session/${code}/select`);
    } catch {
      toast.error("Nu am putut intra în sesiune");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header subtitle="Alătură-te notei" />
      <main className="max-w-md mx-auto px-4 sm:px-6 pt-12">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
          <span className="w-14 h-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center">
            <Receipt size={26} />
          </span>
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mt-5">
            {session?.restaurant_name ? session.restaurant_name : "Decontează nota"}
          </h1>
          <p className="text-muted-foreground mt-2">
            {session?.host_name ? `${session.host_name} a plătit nota.` : ""} Scrie-ți numele ca să alegi ce ai consumat.
          </p>

          <div className="mt-8 bg-card border border-border rounded-[24px] p-5">
            <label className="text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground">Numele tău</label>
            <input
              data-testid="join-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleJoin()}
              placeholder="ex: Maria"
              className="mt-2 w-full bg-secondary rounded-2xl px-4 py-4 text-lg outline-none focus:ring-2 ring-ring"
            />
          </div>

          <button
            data-testid="join-button"
            onClick={handleJoin}
            disabled={loading}
            className="mt-6 w-full bg-primary text-primary-foreground rounded-full py-4 px-6 text-lg font-bold active:scale-[0.98] transition-transform flex justify-center items-center gap-2 disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : <>Intră <ArrowRight size={20} /></>}
          </button>
        </motion.div>
      </main>
    </div>
  );
}
